import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zSampleSettings = z.object({
  // Справочники
  dictSizeVersionId: zUid.nullable(),
  dictRequestTypeId: zUid.nullable(),
  dictRequestStatusId: zUid.nullable(),
  dictFitStatusId: zUid.nullable(),
  dictSampleRequestTypeId: zUid.nullable(),
  // Объекты
  objSampleRequest: zUid.nullable(),
  objSample: zUid.nullable(),
  objSampleComments: zUid.nullable(),
  objSampleMcPoint: zUid.nullable(),
  objSupplier: zUid.nullable(),
  objColor: zUid.nullable(),
  // Sample request
  sampleRequestModelAttrId: zUid.nullable(),
  sampleRequestNameAttrId: zUid.nullable(),
  sampleRequestNumberAttrId: zUid.nullable(),
  sampleRequestColorModelAttrId: zUid.nullable(),
  sampleRequestSupplierNameAttrId: zUid.nullable(),
  sampleRequestDateSendAttrId: zUid.nullable(),
  sampleRequestDateReceiveAttrId: zUid.nullable(),
  sampleRequestRequestTypeAttrId: zUid.nullable(),
  sampleRequestFitStatusAttrId: zUid.nullable(),
  sampleRequestGeneralCommentsAttrId: zUid.nullable(),
  sampleRequestSamplesAttrId: zUid.nullable(),
  // Sample
  sampleSampleRequestAttrId: zUid.nullable(),
  sampleNameAttrId: zUid.nullable(),
  sampleQuantityAttrId: zUid.nullable(),
  sampleSizeAttrId: zUid.nullable(),
  sampleSizeVersionAttrId: zUid.nullable(),
  sampleRequestTypeAttrId: zUid.nullable(),
  sampleReviewDateAttrId: zUid.nullable(),
  sampleRequestStatusAttrId: zUid.nullable(),
  sampleCommentsAttrId: zUid.nullable(),
  sampleMcPointsAttrId: zUid.nullable(),
  sampleSampleCommentsAttrId: zUid.nullable(),
  // Sample comments
  sampleCommentsSampleAttrId: zUid.nullable(),
  sampleCommentsImageAttrId: zUid.nullable(),
  sampleCommentsCommentsAttrId: zUid.nullable(),
  // Sample mc points
  sampleMcPointSampleAttrId: zUid.nullable(),
  sampleMcPointMcPointValueAttrId: zUid.nullable(),
  sampleMcPointMeasuredValueAttrId: zUid.nullable(),
  // Supplier
  supplierSupplierNameAttrId: zUid.nullable(),
  supplierSupplierShortNameAttrId: zUid.nullable(),
  supplierCountryAttrId: zUid.nullable(),
  supplierAddressAttrId: zUid.nullable(),
  // Color
  colorColorArticleAttrId: zUid.nullable(),
});
export type ZSampleSettings = z.infer<typeof zSampleSettings>;
